export default {
  name: "Wifi",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M24.8 17.4c-.36 0-.72-.2-.89-.55C23.82 16.68 21.84 13 16 13c-5.91 0-7.89 3.81-7.91 3.85-.25.49-.85.7-1.34.45a1.01 1.01 0 0 1-.45-1.34C6.41 15.75 8.86 11 16 11s9.59 4.75 9.69 4.95c.25.49.05 1.09-.45 1.34-.14.08-.29.11-.44.11zm4.16-4.51c.49-.25.68-.86.43-1.35C29.25 11.27 25.9 5 16 5S2.75 11.27 2.61 11.54a.994.994 0 0 0 .43 1.34c.49.26 1.09.07 1.35-.42C4.5 12.24 7.38 7 16 7s11.5 5.24 11.61 5.46c.18.35.53.54.89.54.16 0 .31-.04.46-.11zM18 25c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm3.37-3.07c.51-.2.76-.79.56-1.3-.06-.15-1.5-3.63-5.93-3.63s-5.87 3.48-5.93 3.63c-.21.51.04 1.09.56 1.3.51.2 1.1-.04 1.3-.56.01-.02.98-2.37 4.07-2.37 3.02 0 4.02 2.26 4.07 2.38a1.011 1.011 0 0 0 1.3.55z",
  },
}
